import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Produto } from '../models/produto';

@Injectable({
  providedIn: 'root',
})
export class ProdutoService {
  private url = `${environment.apiUrl}/produtos`;

  constructor(private http: HttpClient) {}

  selecionar(): Observable<Produto[]> {
    return this.http.get<Produto[]>(this.url);
  }

  cadastrar(obj: Produto): Observable<Produto> {
    return this.http.post<Produto>(this.url, obj);
  }

  alterar(id: number, obj: Produto): Observable<Produto> {
    return this.http.put<Produto>(`${this.url}/${id}`, obj);
  }

  pesquisar(search: string) {
    return this.http.get<Produto[]>(
      `${this.url}/produto-ou-codigo-barras/${search}`
    );
  }

  ativarDesativar(id: number, ativo: boolean = false): Observable<Produto> {
    return this.http.patch<Produto>(`${this.url}/${id}/ativo?ativo=${ativo}`, null as any);
  }  
}
